import { render, staticRenderFns } from "./CouponTable.vue?vue&type=template&id=6ae345fc&scoped=true"
import script from "./CouponTable.vue?vue&type=script&lang=ts"
export * from "./CouponTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae345fc",
  null
  
)

export default component.exports